function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,5h30v20H0V5Z",
    style: {
      fill: "#c1272d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.939,19.045l-2.939-2.135-2.939,2.135,1.122-3.455-2.939-2.135h3.633l1.123-3.455,1.122,3.455h3.633l-2.939,2.135,1.123,3.455ZM15.404,16.616l1.63,1.184-.623-1.917-1.007.733ZM13.588,15.884l-.623,1.917,1.63-1.184-1.007-.733ZM13.743,15.409l1.257.913,1.257-.914-.48-1.478h-1.554l-.48,1.479ZM16.277,13.93l.385,1.185,1.63-1.185h-2.015ZM11.708,13.93l1.63,1.185.385-1.185h-2.015ZM14.377,13.455h1.245l-.622-1.917-.623,1.917Z",
    style: {
      fill: "#006233"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMa);
export default __webpack_public_path__ + "static/media/MA.7ac153f75ea861d9d3f12a779641ef73.svg";
export { ForwardRef as ReactComponent };